import { DOMAINS } from '../../constants/selectLists/contriesList'

export const getAppDomainName = () => {
  const currentAppUrl = window.location.href

  if (currentAppUrl.includes(DOMAINS.crowdcatch)) {
    return 'CrowdCatch'
  } else {
    return 'PartnerBrite'
  }
}

export const getPartnerbrainName = () => {
  const currentAppUrl = window.location.href

  if (currentAppUrl.includes(DOMAINS.crowdcatch)) {
    return 'CrowdCatch'
  } else {
    return 'Partnerbrain'
  }
}
